import { render, staticRenderFns } from "./UnableToAttend.vue?vue&type=template&id=ef728f96&"
import script from "./UnableToAttend.vue?vue&type=script&lang=js&"
export * from "./UnableToAttend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports